<div class="visitor-leave-summary">
    <sc-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-leave-summary.description"></sc-dictionary-label>
    </sc-title>

    <div class="success">
        <sc-icon iconClass="fa-check-circle"></sc-icon>
    </div>

</div>
